import React from 'react';
import { useSelector } from 'react-redux';
import { Wrapper, MenuItem } from 'react-aria-menubutton';
import { useT } from '~app/core/BundleProvider';

const FileMenu = ({ closeMenu, handleSelect, exitCanvas, resetModel }) => {
  const t = useT();
  const doc = useSelector(state => state.document.present);
  return (
    <Wrapper
      className="FileMenu__menu"
      onSelection={handleSelect}
      id="wrapper-menu"
      role="menu"
      aria-label="File Menu"
    >
      <Wrapper className="FileMenu__menu" onSelection={handleSelect}>
        {doc ? (
          <MenuItem
            tabIndex="0"
            className="FileMenu__submenu"
            value="save-options"
            aria-label={t('save')}
            id="save-file"
          >
            {t('save')}
          </MenuItem>
        ) : (
          <div
            className="FileMenu__menu-item FileMenu__menu-item-disabled"
            aria-label="Save As File"
          >
            {t('save')}
          </div>
        )}
      </Wrapper>
      <Wrapper className="FileMenu__menu" onSelection={() => resetModel()}>
        <MenuItem
          tabIndex="0"
          className="FileMenu__submenu"
          aria-label="Reset Model"
        >
          {t('reset')}
        </MenuItem>
      </Wrapper>
      <Wrapper className="FileMenu__menu" onSelection={() => exitCanvas()}>
        <MenuItem
          tabIndex="0"
          className="FileMenu__submenu"
          aria-label="Main Menu"
        >
          {t('home')}
        </MenuItem>
      </Wrapper>
      <Wrapper
        className="FileMenu__menu"
        onSelection={() => closeMenu('wrapper-menu')}
      >
        <MenuItem
          tabIndex="0"
          className="FileMenu__close-icon"
          aria-label={t('close-menu')}
        >
          &#10006;
        </MenuItem>
      </Wrapper>
    </Wrapper>
  );
};

export default FileMenu;
